/**
 * simTrace.ts · Sim trace wire types (Phase 4)
 * Mirrors backend/sim/writer.py — Phase 4 fetches the full trace JSON
 * from GET /api/sim_runs/{id}/trace. The stub subset lives at the bottom
 * as `SimTraceStub` for legacy Phase 3 callers.
 */
/** Fold a live SimTrace into the stub-shape ABChart already reads. */
export function toSimTraceStub(trace, targetHeadwayS = 300) {
    const s = trace.summary ?? {};
    const num = (k, fallback = 0) => typeof s[k] === "number" && Number.isFinite(s[k])
        ? s[k]
        : fallback;
    return {
        controller: trace.controller,
        scenario: trace.scenario,
        seed: trace.seed,
        duration_s: trace.duration_s,
        target_headway_s: targetHeadwayS,
        summary: {
            controller: trace.controller,
            seed: trace.seed,
            mean_wait_s: num("mean_wait_s"),
            max_headway_s: num("max_headway_s"),
            min_headway_s: num("min_headway_s"),
            bunches: Math.round(num("bunches")),
            overflow_boardings: Math.round(num("overflow_boardings")),
            boardings_count: Math.round(num("boardings_count")),
            arrivals_count: Math.round(num("arrivals_count")),
        },
        timeseries: {
            ts: trace.timeseries?.ts ?? [],
            headways: trace.timeseries?.headways ?? {},
        },
    };
}
